import React, { useState, useEffect } from 'react'
import styles from './Textarea.module.scss'
import { TextareaProps } from './Textarea'

interface ITextareaViewProps extends TextareaProps {
  setIsFocus: (isFocus: boolean) => void
  classNameValueFocus: (
    value: string | number,
    isFocus: boolean,
    isFixed: boolean
  ) => string
  changeTextarea: (event: React.ChangeEvent<HTMLTextAreaElement>) => void
}
export type TextareaViewProps = ITextareaViewProps

export const useTextarea = (props: TextareaProps): TextareaViewProps => {
  const [value, setValue] = useState(props.value)
  const [label, setLabel] = useState(props.label)
  const [isFixed, setIsFixed] = useState(props.isFixed)
  const [reference, setReference] = useState(props.reference)
  const [disabled, setDisabled] = useState(props.disabled)
  const [isFocus, setIsFocus] = useState(props.isFocus)
  const [isDashed, setIsDashed] = useState(props.isDashed)

  useEffect(() => {
    return () => {
      setValue(null)
      setLabel(null)
      setIsFixed(false)
      setReference(null)
      setDisabled(false)
      setIsFocus(false)
      setIsDashed(false)
    }
  }, [])

  useEffect(() => {
    setValue(props.value)
    setLabel(props.label)
    setIsFixed(props.isFixed)
    setReference(props.reference)
    setDisabled(props.disabled)
    setIsFocus(props.isFocus)
    setIsDashed(props.isDashed)
  }, [
    props.value,
    props.label,
    props.isFixed,
    props.reference,
    props.disabled,
    props.isFocus,
    props.isDashed
  ])

  const classNameValueFocus = (
    value: string | number | null,
    isFocus: boolean,
    isFixed: boolean
  ): string | null => {
    if (isFocus) {
      return styles._field__box_value + ' ' + styles._field__box_focused
    } else if (isFixed) {
      return styles._field__box_value
    } else if (value) {
      return styles._field__box_value
    }

    return null
  }

  const changeTextarea = (event: React.ChangeEvent<HTMLTextAreaElement>): void => {
    setValue(event.target.value || null)
    if (props.onChange) {
      props.onChange(event)
    }
  }

  return {
    value,
    label,
    isFixed,
    reference,
    disabled,
    isFocus,
    setIsFocus,
    isDashed,
    classNameValueFocus,
    changeTextarea
  }
}
